/**
 * Diskret outbound-pil (nord-øst) – inline SVG i currentColor.
 * Erstatter unicode ↗ som renderes inkonsistent på iOS/Android og
 * ofte brækker linje som sidste tegn. Pak sidste ord + <OutboundArrow />
 * i en whitespace-nowrap span, så pilen aldrig lander alene.
 */
export function OutboundArrow({
  className = "",
  size = 10,
}: {
  className?: string;
  size?: number;
}) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      viewBox="0 0 10 10"
      width={size}
      height={size}
      className={`inline-block align-[-0.05em] ml-[0.25em] shrink-0 ${className}`}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M2.5 7.5 L7.5 2.5" />
      <path d="M3.5 2.5 H7.5 V6.5" />
    </svg>
  );
}
